/* DI LUSSO · Franja de compra rápida en tarjetas de producto.
   Al tocar una talla o "Agregar al carrito": pasa la variante exacta al botón
   de carrito nativo (oculto) de la tarjeta y lo ejecuta, para que Gecko
   agregue el producto y abra el carrito.
   Funciona también con productos cargados por scroll infinito o filtros. */
(function () {
  if (window.__DL_SIZE_SELECTOR__) return;
  window.__DL_SIZE_SELECTOR__ = true;

  var TRIGGER = '.dl-size-selector [data-dl-variant]';

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest(TRIGGER);
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();

    var card = trigger.closest('.t4s-product');
    var selector = trigger.closest('.dl-size-selector');
    if (!card || !selector) return;

    if (trigger.classList.contains('dl-size-pill')) {
      selector.querySelectorAll('.dl-size-pill.is-selected').forEach(function (item) {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      trigger.classList.add('is-selected');
      trigger.setAttribute('aria-pressed', 'true');
    } else {
      trigger.classList.add('is-loading');
      setTimeout(function () { trigger.classList.remove('is-loading'); }, 1500);
    }

    var variantId = trigger.getAttribute('data-dl-variant');
    var atc = card.querySelector('.dl-size-hidden-atc');
    if (!variantId || !atc) return;

    atc.setAttribute('data-variant-id', variantId);
    atc.setAttribute('href', (atc.getAttribute('href') || '').split('?')[0] + '?variant=' + variantId);
    atc.click();
  }, false);

  /* Evita que el enlace general de la tarjeta intercepte el toque */
  document.addEventListener('mousedown', function (event) {
    if (event.target.closest && event.target.closest('.dl-size-selector')) event.stopPropagation();
  }, false);
  document.addEventListener('touchstart', function (event) {
    if (event.target.closest && event.target.closest('.dl-size-selector')) event.stopPropagation();
  }, { passive: true });
})();
